import React, { useEffect } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Polyline,
  Marker,
  InfoWindow,
  GroundOverlay,
} from "@react-google-maps/api";
import logo from "../../assets/icons8-left-50.png";
import lockedwaypointLogo from "../../assets/locked-waypoint.png";
import unlockedWaypointLogo from "../../assets/unlocked-waypoint.png";
import openableWaypointLogo from "../../assets/openable-waypoint.png";
import flagIcon from "../../assets/flag-icon.png";
import startIcon from "../../assets/start-icon.png";
import paceIcon from "../../assets/paceicon.png";
import friendIcon from "../../assets/friend-marker.png";
import icon from "../../assets/marker.png";
import userIcon from "../../assets/userMarker.png";
import "./style.css";
import "../../styles/modernDashboard.css";
import {
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  getUsersByProductId,
  getChallengeById,
  getWaypointsById,
  getUserActivity,
  checkChallengeValidity,
} from "../../globalService/api.service";
import WaypointModal from "./WaypointModal";
import EvidenceModal from "./EvidenceModal";
import Activity from "./Activity";
import CompletionModal from "./CompletionModal";

const googleMapsApiKey = "AIzaSyAFgWyTzNPhooiqiZJIr-Judt3Wo14w6GE";
const containerStyle = {
  width: "100%",
  height: "100%",
  touchAction: "none",
};
const colorMap = {
  "78327": "#FFD700",
  "123456": "#00FF00",
  "78177": "#6E3B07",
  "79174": "#BA8E23",
  "79175": "#BA8E23",
  "84396": "#FFEE8C",
  "4846": "#06402B",
  "7859": "#E9D4A825",
  "7840": "#E9D4A825",
  "7578": "#E9D4A850",
  "7109": "#06402B50",
  "7687": "#000000",
  "7532": "#E9D4A8",
  "8146": "#E9D4A820",
  "88189": "#E9D4A820",
  "7197": "#E9D4A800",
  "7198": "#E9D4A800",
  "7199": "#E9D4A800",
  "7200": "#E9D4A800",
  "7201": "#E9D4A800",
  "7316": "#E9D4A875",
  "7308": "#E9D4A810",
  "7278": "#E9D4A810",
  "78178": "#6E3B07",
  "7237": "#6E3B0700",
  "7238": "#6E3B0700",
  "7239": "#6E3B0700",
  "7249": "#6E3B0700",
  "7044": "#6E3B0700",
  "6991": "#6E3B0700",
  "59455": "#6E3B0700",
  "7158": "#6E3B0700",
  "8052": "#D4AF3775",
  "8164": "#E9D4A810",
  "8166": "#E9D4A810",
  "8168": "#E9D4A810",
  "59328": "#E9D4A820",
  "89796": "#6E3B0700",
  "90432": "#6E3B0700",
  "90433": "#6E3B0700",
  "91366": "#6E3B0700",
  "92279": "#6E3B0700",
  "AROUND80": "#6E3B0700",
  "7255": "#E9D4A810",
};
const opacityMap = {
  "78327": 0.4,
  "12345": 0.6,
};
const timeframes = [
  { label: "1 days", days: 1 },
  { label: "3 days", days: 3 },
  { label: "7 days", days: 7 },
  { label: "15 days", days: 15 },
  { label: "30 days", days: 30 },
  { label: "45 days", days: 45 },
  { label: "60 days", days: 60 },
  { label: "90 days", days: 90 },
  { label: "120 days", days: 120 },
  { label: "6 months", days: 182 },
  { label: "1 year", days: 365 },
];

const thStyle: React.CSSProperties = {
  textAlign: "left" as const,
  padding: "7px 10px",
  borderBottom: "1.5px solid #ddd"
};
const tdStyle: React.CSSProperties = {
  padding: "7px 10px",
  borderBottom: "1px solid #eee"
};

const formatDate = (iso?: string) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};


function LeaderboardTable({ users, searchName, currentUserId, maxDistance }) {
  const sorted = React.useMemo(() => {
    return [...(users || [])]
      .sort((a, b) => b.percentage - a.percentage)
      .map((user, i) => ({ ...user, rank: i + 1 }));
  }, [users]);
  const userRank = sorted.find(u => u.userId === currentUserId)?.rank || "N/A";
  const filtered = searchName
    ? sorted.filter(u =>
        u.name && u.name.toLowerCase().includes(searchName.toLowerCase())
      )
    : sorted;
  return (
    <div style={{overflowX: "auto"}}>
      <div style={{
        marginBottom: 14,
        fontSize: 15,
        fontWeight: 600,
        color: "#277"
      }}>
        Your position: {userRank} of {sorted.length}
      </div>
      <table style={{width: "100%", borderCollapse: "collapse"}}>
        <thead>
          <tr>
            <th style={thStyle}>#</th>
            <th style={thStyle}>Name</th>
            <th style={thStyle}>%</th>
            <th style={thStyle}>Distance</th>
          </tr>
        </thead>
        <tbody>
          {filtered.length === 0 && (
            <tr>
              <td colSpan={4} style={{padding: 16, textAlign: "center", color: "#888"}}>
                No users found.
              </td>
            </tr>
          )}
          {filtered.map(user => (
            <tr key={user.userId}
              style={{
                background: user.userId === currentUserId ? "#eaf7ff" : undefined,
                fontWeight: user.userId === currentUserId ? 700 : undefined
              }}
            >
              <td style={{ ...tdStyle, fontWeight: 700 }}>{user.rank}</td>
              <td style={tdStyle}>{user.name}</td>
              <td style={tdStyle}>{user.percentage >= 100 ? "100%" : Math.floor(user.percentage) + "%"}</td>
              <td style={tdStyle}>{Math.floor(Math.min(user.distanceKm, maxDistance))} km</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function ViewMap() {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googleMapsApiKey,
  });

  const params = useParams();
  const { productId, userId } = params;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const app = searchParams.get("app");

  // Challenge ids where the dock actions should be disabled
  const activityDisabledChallengeIds = ["AROUND80"];
  const moreDisabledChallengeIds = ["AROUND80"];

  const isActivityDisabled = activityDisabledChallengeIds.includes(String(productId));
  const isMoreDisabled = moreDisabledChallengeIds.includes(String(productId));

  // === State
  const [selectedTimeframe, setSelectedTimeframe] = React.useState(() => {
    try {
      if (!productId) return null;
      const saved = localStorage.getItem(`selectedTimeframe_${productId}`);
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  const [timeLeft, setTimeLeft] = React.useState<string | null>(null);
  const [paceMarker, setPaceMarker] = React.useState<any>(null);

  const [challenge, setChallenge] = React.useState<any>(null);
  const [googleObj, setGoogleObj] = React.useState<any>(null);
  const [users, setUsers] = React.useState<any[]>([]);
  const [polyline, setPolyline] = React.useState<any>(null);
  const [markers, setMarkers] = React.useState<any[]>([]);
  const [infoWindow, setInfoWindow] = React.useState<any>(null);
  const [center, setCenter] = React.useState<{ lat: number; lng: number }>({ lat: 0, lng: 0 });
  const [waypointsData, setWaypointsData] = React.useState<any[]>([]);
  const [waypoints, setWaypoints] = React.useState<any[]>([]);
  const [waypoint, setWaypoint] = React.useState<any>(null);
  const [activity, setActivity] = React.useState<any>(null);
  const [pace, setPace] = React.useState<number | null>(null);
  const [isOn, setIsOn] = React.useState(false);
  const [isWpModalOpen, setIsWpModalOpen] = React.useState<string>("");
  const [isEvModalOpen, setIsEvModalOpen] = React.useState<boolean>(false);
  const [showCompletionModal, setShowCompletionModal] = React.useState(false);
  const [showMoreSheet, setShowMoreSheet] = React.useState(false);
  const [moreTab, setMoreTab] = React.useState<"timeframe" | "leaderboard" | "friends">(
    "timeframe"
  );
  const [searchName, setSearchName] = React.useState("");
  const [friendNameInput, setFriendNameInput] = React.useState("");
  const [friendNames, setFriendNames] = React.useState(() => {
    try {
      return JSON.parse(localStorage.getItem("challengeFriends") || "[]");
    } catch {
      return [];
    }
  });

  // --- MAP LOAD
  const onMapLoad = async () => {
    setGoogleObj(window.google);
  };

  // --- NAVIGATION
  const goBack = () => {
    navigate(-1);
  };

  // --- TIMEFRAME HANDLERS
  const handleTimeframeChange = (e) => {
    const selected = timeframes.find((t) => t.label === e.target.value);
    if (!selected) return;

    // Capture the user's current progress *at the moment they set the timeframe*.
    // This becomes the baseline so the pacer starts from "where you are", not from 0.
    let baselineKm = 0;
    try {
      const currentUser = users?.find((u) => u.userId === userId);
      const totalKm = Number(challenge?.totalDistanceKm ?? 0);
      const currentKm = Number(currentUser?.distanceKm ?? 0);
      if (Number.isFinite(currentKm) && currentKm > 0) baselineKm = currentKm;
      if (Number.isFinite(totalKm) && totalKm > 0) baselineKm = Math.min(baselineKm, totalKm);
    } catch {
      baselineKm = 0;
    }

    // When a user sets a timeframe, we start the pace countdown from *now* (when they set it).
    const next = {
      ...selected,
      startDate: new Date().toISOString(),
      baselineKm,
    };

    setInfoWindow(null);
    setPaceMarker(null);
    setSelectedTimeframe(next);

    // Reload data so the UI reflects the new pacing context
    getUser();
    getChallenge();
    getWaypointsFromAPI();
  };

  const handleResetTimeframe = () => {
    setInfoWindow(null);
    setPaceMarker(null);
    setTimeLeft(null);
    setSelectedTimeframe(null);

    if (productId) {
      try {
        localStorage.removeItem(`selectedTimeframe_${productId}`);
      } catch {}
    }

    // Reload back to default pace
    getUser();
    getChallenge();
    getWaypointsFromAPI();
  };

  // --- COUNTDOWN EFFECT
  useEffect(() => {
    if (!selectedTimeframe) {
      setTimeLeft(null);
      return;
    }
    const updateCountdown = () => {
      const now = new Date();
      const start = new Date(selectedTimeframe.startDate);
      const end = new Date(start.getTime() + selectedTimeframe.days * 86400000);
      const diff = end.getTime() - now.getTime();
      if (diff <= 0) {
        setTimeLeft("Time's up!");
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      setTimeLeft(`${days}d ${hours}h`);
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [selectedTimeframe]);
  useEffect(() => {
    // Save with per-challenge key
    if (!productId) return;
    try {
      if (selectedTimeframe) {
        localStorage.setItem(`selectedTimeframe_${productId}`, JSON.stringify(selectedTimeframe));
      } else {
        localStorage.removeItem(`selectedTimeframe_${productId}`);
      }
    } catch {}
  }, [selectedTimeframe, productId]);

  // --- API LOADERS
  useEffect(() => {
    localStorage.setItem("brandId", params.brandId!);
    getUser();
    getChallenge();
    getWaypointsFromAPI();
    if (userId) generateWaypoints();
    if (app) handleOpenEvModal();
    // eslint-disable-next-line
  }, []);

  const getWaypointsFromAPI = async () => {
    let data = await getWaypointsById(productId!, userId!);
    if (!Array.isArray(data)) data = [];
    setWaypointsData(data);
  };
  const getUser = async () => {
    const paceData = await checkChallengeValidity(productId!, userId!);
    setPace(parseFloat(paceData.pace));
    let userData = await getUsersByProductId(productId!, userId!);
    if (!Array.isArray(userData)) userData = [];
    let userActivity = await getUserActivity(productId!, userId!);
    setUsers(userData);
    setActivity(userActivity);
  };
  const getChallenge = async () => {
    const data = await getChallengeById(productId!);
    if (data.length)
      setChallenge({
        ...data[0],
        pathCoordinates: JSON.parse(data[0].pathCoordinates || "null"),
      });
  };

  // --- PACE MARKER LOGIC
  useEffect(() => {
    if (googleObj && polyline && challenge) {
      // If per-challenge timeframe is set:
      if (selectedTimeframe && selectedTimeframe.startDate) {
        const now = new Date();
        const start = new Date(selectedTimeframe.startDate);
        const end = new Date(start.getTime() + selectedTimeframe.days * 86400000);
        const totalMs = end.getTime() - start.getTime();
        const elapsedMs = now.getTime() - start.getTime();
        const f = Math.min(Math.max(elapsedMs / totalMs, 0), 1);

        const totalKm = Number(challenge?.totalDistanceKm ?? 0);
        const baselineKm = Number(selectedTimeframe?.baselineKm ?? 0);
        const safeTotalKm = Number.isFinite(totalKm) && totalKm > 0 ? totalKm : 0;
        const safeBaselineKm = Number.isFinite(baselineKm) && baselineKm > 0 ? Math.min(baselineKm, safeTotalKm || baselineKm) : 0;

        // Re-pace from current progress: baseline + fraction * remaining.
        const remainingKm = safeTotalKm ? Math.max(0, safeTotalKm - safeBaselineKm) : 0;
        const expectedKm = safeTotalKm ? (safeBaselineKm + f * remainingKm) : 0;
        const pct = safeTotalKm ? (expectedKm / safeTotalKm) * 100 : (f * 100);

        const distanceTarget = safeTotalKm ? expectedKm : null;
        const position = getPositionByPercentage(pct || 0.01);
        setPaceMarker(
          <Marker
            key={`pace-tf-${selectedTimeframe.startDate}-${selectedTimeframe.days}-${safeBaselineKm}`}
            onClick={() =>
              handlePaceMarkerClick(position, pct, distanceTarget, { expectedKm, totalKm: safeTotalKm })
            }
            position={position}
            icon={paceIcon}
          />
        );
      }
      // Else use fallback: original pace logic
      else if (pace != null) {
        const position = getPositionByPercentage(pace);
        setPaceMarker(
          <Marker
            key={`pace-default-${pace}`}
            onClick={() => handlePaceMarkerClick(position, pace)}
            position={position}
            icon={paceIcon}
          />
        );
      } else {
        setPaceMarker(null);
      }
    } else {
      setPaceMarker(null);
    }
  }, [googleObj, polyline, selectedTimeframe, challenge, timeLeft, pace]);

  // --- MODAL HANDLERS
  const handleOpenWpModal = (wp, position, is_openable, is_unlocked) => {
    if (is_openable || is_unlocked) {
      setIsWpModalOpen(is_unlocked ? "is_unlocked" : "is_openable");
      setWaypoint(wp);
    } else {
      setInfoWindow(
        <InfoWindow
          onCloseClick={() => setInfoWindow(null)}
          position={position}
        >
          <div>
            <p>
              This waypoint is locked. Your previous waypoints may be locked or
              you have not yet reached this point. To unlock a waypoint you have 
              passed please press the complete button in the waypoint.
            </p>
          </div>
        </InfoWindow>
      );
    }
  };
  const handleOpenEvModal = () => setIsEvModalOpen(true);
  const handleCloseWpModal = () => { setIsWpModalOpen(""); setWaypoint(null); };
  const handleCloseEvModal = () => setIsEvModalOpen(false);

  const getWaypointLogo = (is_openable, is_unlocked) => {
    if (is_openable || is_unlocked) {
      if (is_unlocked) return unlockedWaypointLogo;
      else if (is_openable) return openableWaypointLogo;
    } else return lockedwaypointLogo;
  };

  const options = {
    strokeColor: "#00BFFF",
    strokeOpacity: 1.0,
    strokeWeight: 4,
    fillColor: "#FF0000",
    fillOpacity: 0.35,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    radius: 30000,
    zIndex: 1,
  };

  // Center the map based on challenge coordinates
  useEffect(() => {
    if (challenge) {
      const { pathCoordinates } = challenge;
      const getCenterLat = () => {
        const centerPoint = pathCoordinates[Math.floor(pathCoordinates.length / 2)];
        return centerPoint.lat;
      };
      const getCenterLng = () => {
        const centerPoint = pathCoordinates[Math.floor(pathCoordinates.length / 2)];
        return centerPoint.lng;
      };
      setCenter({
        lat: pathCoordinates ? getCenterLat() : 51.49336,
        lng: pathCoordinates ? getCenterLng() : -0.13752,
      });
    }
  }, [challenge]);

  // --- WAYPOINTS
  function generateWaypoints() {
    const waypointUI = waypointsData.map((waypoint) => {
      const position = getPositionByPercentage(waypoint.percentage);
      return (
        <Marker
          onClick={() =>
            handleOpenWpModal(
              waypoint,
              position,
              waypoint.is_openable,
              waypoint.is_unlocked
            )
          }
          position={position}
          icon={getWaypointLogo(waypoint.is_openable, waypoint.is_unlocked)}
          key={new Date().toISOString()}
          animation={googleObj && googleObj.maps && googleObj.maps.Animation ? googleObj.maps.Animation.DROP : undefined}
        />
      );
    });
    if (
      challenge &&
      challenge.pathCoordinates &&
      challenge.pathCoordinates.length > 0
    ) {
      const firstCoordinate = challenge.pathCoordinates[0];
      const startCoordinateMarker = (
        <Marker
          position={{ lat: firstCoordinate.lat, lng: firstCoordinate.lng }}
          icon={startIcon}
          key="startCoordinate"
        />
      );
      const lastCoordinate =
        challenge.pathCoordinates[challenge.pathCoordinates.length - 1];
      const lastCoordinateMarker = (
        <Marker
          position={{ lat: lastCoordinate.lat, lng: lastCoordinate.lng }}
          icon={flagIcon}
          key="lastCoordinate"
        />
      );
      setWaypoints([
        ...waypointUI,
        startCoordinateMarker,
        lastCoordinateMarker,
      ]);
    } else {
      setWaypoints([...waypointUI]);
    }
  }

  // --- MARKERS
  const getMarkers = () => {
    const filteredUsers = isOn
      ? users
      : users.filter((user) => user.userId === userId);
    const userMarkers = filteredUsers.map((user) => {
      const position = getPositionByPercentage(user.percentage);
      const isFriend = friendNames.some(
        name => user.name && user.name.toLowerCase() === name.toLowerCase()
      );
      return (
        <Marker
          onClick={() => markerClickedHandler(user, position)}
          position={position}
          animation={
            user.userId === userId
              ? (googleObj && googleObj.maps && googleObj.maps.Animation ? googleObj.maps.Animation.BOUNCE : undefined)
              : isFriend
              ? (googleObj && googleObj.maps && googleObj.maps.Animation ? googleObj.maps.Animation.DROP : undefined)
              : undefined
          }
          icon={
            user.userId === userId
              ? challenge?.customUserIcon
                ? challenge.customUserIcon
                : userIcon
              : isFriend
              ? friendIcon
              : icon
          }
          key={user.userId}
        />
      );
    });
    setMarkers(userMarkers);
    if (users && users.length && userId) {
      const currentUser = users.find((user) => user.userId === userId);
      if (currentUser) {
        const position = getPositionByPercentage(currentUser.percentage);
        setCenter(position);
      }
    }
  };

  useEffect(() => {
    if (polyline) {
      challenge && getMarkers();
      getWaypointsFromAPI();
    }
  }, [polyline, users]);
  useEffect(() => {
    getMarkers();
  }, [isOn, friendNames]);
  useEffect(() => {
    if (userId && waypointsData && googleObj) generateWaypoints();
  }, [waypointsData]);
  useEffect(() => {
    if (!productId) return;
    if (
      users &&
      userId &&
      localStorage.getItem(`completionModalShown_${productId}`) !== "true"
    ) {
      const currentUser = users.find((user) => user.userId === userId);
      if (currentUser && currentUser.percentage >= 100) {
        setShowCompletionModal(true);
      }
    }
  }, [users, userId, productId]);
  const markerClickedHandler = (user, position) => {
    setInfoWindow(
      <InfoWindow onCloseClick={() => setInfoWindow(null)} position={position}>
        <div>
          {userId && userId === user.userId && (
            <>
              <span style={{ color: "black", fontWeight: "bold" }}>
                Id:{" "}
                <span style={{ color: "blue", fontWeight: "bold" }}>
                  {user.userId}
                </span>
              </span>
              <br />
            </>
          )}
          <span style={{ color: "black", fontWeight: "bold" }}>
            Name:{" "}
            <span style={{ color: "bronze", fontWeight: "bold" }}>
              {user.name}
            </span>
          </span>
          <br />
          <span style={{ color: "black", fontWeight: "bold" }}>
            Distance:{" "}
            <span style={{ color: "bronze", fontWeight: "bold" }}>
              {user.distanceKm} km
            </span>
          </span>
          <br />
          <span style={{ color: "black", fontWeight: "bold" }}>
            %:{" "}
            <span style={{ color: "bronze", fontWeight: "bold" }}>
              {user.percentage}
            </span>
          </span>
        </div>
      </InfoWindow>
    );
  };

  // --- POSITION CALCULATION
  const getPositionByPercentage = (percentage) => {
    if (!percentage) percentage = 0.01;
    if (percentage > 100) percentage = 100;
    if (!polyline) return center;
    if (googleObj && googleObj.maps && googleObj.maps.LatLng) {
      googleObj.maps.LatLng.prototype.distanceFrom = function (newLatLng) {
        const EarthRadiusMeters = 6378137.0;
        const lat1 = this.lat();
        const lon1 = this.lng();
        const lat2 = newLatLng.lat();
        const lon2 = newLatLng.lng();
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const a =
          Math.sin(dLat / 2) ** 2 +
          Math.cos(lat1 * (Math.PI / 180)) *
            Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) ** 2;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return EarthRadiusMeters * c;
      };
    }
    if (googleObj && googleObj.maps && googleObj.maps.Polyline) {
      googleObj.maps.Polyline.prototype.Distance = function () {
        let dist = 0;
        for (let i = 1; i < this.getPath().getLength(); i++) {
          dist += this.getPath().getAt(i).distanceFrom(
            this.getPath().getAt(i - 1)
          );
        }
        return dist;
      };
    }
    const distance = Math.floor((polyline.Distance() * percentage) / 100);
    if (!distance) return center;
    function GetPointAtDistance(metres) {
      if (metres === 0) return polyline.getPath().getAt(0);
      if (metres < 0) return null;
      if (polyline.getPath().getLength() < 2) return null;
      let dist = 0,
        olddist = 0,
        i;
      for (i = 1; i < polyline.getPath().getLength() && dist < metres; i++) {
        olddist = dist;
        dist += polyline.getPath().getAt(i).distanceFrom(
          polyline.getPath().getAt(i - 1)
        );
      }
      if (dist < metres) return null;
      const p1 = polyline.getPath().getAt(i - 2);
      const p2 = polyline.getPath().getAt(i - 1);
      const m = (metres - olddist) / (dist - olddist);
      return new googleObj.maps.LatLng(
        p1.lat() + (p2.lat() - p1.lat()) * m,
        p1.lng() + (p2.lng() - p1.lng()) * m
      );
    }
    const point = GetPointAtDistance(distance);
    return { lat: point.lat(), lng: point.lng() };
  };

  // --- PACE MARKER POPUP
  const handlePaceMarkerClick = (
    position,
    paceValue,
    distanceTarget?,
    details?: { expectedKm?: number; totalKm?: number }
  ) => {
    const totalKm =
      typeof details?.totalKm === "number" && details.totalKm > 0
        ? details.totalKm
        : Number(challenge?.totalDistanceKm ?? 0);
    const expectedKm =
      typeof details?.expectedKm === "number" && details.expectedKm >= 0
        ? details.expectedKm
        : typeof distanceTarget === "number"
        ? distanceTarget
        : null;

    setInfoWindow(
      <InfoWindow onCloseClick={() => setInfoWindow(null)} position={position}>
        <div>
          <h3>Pace marker</h3>
          {expectedKm != null && totalKm > 0 ? (
            <p>
              To be on track you should be at <strong>{expectedKm.toFixed(1)} km</strong> of {totalKm} km (
              {Math.round(paceValue || 0)}%)
            </p>
          ) : (
            <p>
              To be on track you should be at <strong>{Math.round(paceValue || 0)}%</strong>
            </p>
          )}

          {selectedTimeframe?.startDate ? (
            <p style={{ marginTop: 8, fontSize: 12, opacity: 0.8 }}>
              Timeframe started: {formatDate(selectedTimeframe.startDate)}
            </p>
          ) : null}
        </div>
      </InfoWindow>
    );
  };

  // --- FRIENDS HANDLERS
  const handleAddFriend = () => {
    const trimmed = friendNameInput.trim();
    if (!trimmed) return;
    if (!friendNames.includes(trimmed)) {
      const updated = [...friendNames, trimmed];
      setFriendNames(updated);
      localStorage.setItem("challengeFriends", JSON.stringify(updated));
    }
    setFriendNameInput("");
  };

  // --- MAP OPTIONS
  const getMapOptions = () => {
    const baseOptions = {
      gestureHandling: "greedy",
      // Keep Google controls clear of the bottom dock.
      // We prefer top-right controls so the dock never blocks zoom buttons.
      zoomControl: true,
      zoomControlOptions:
        window.google?.maps?.ControlPosition
          ? { position: window.google.maps.ControlPosition.RIGHT_TOP }
          : undefined,
      restriction:
        challenge?.bounds && challenge.bounds !== "null"
          ? { latLngBounds: JSON.parse(challenge.bounds) }
          : undefined,
      minZoom:
        challenge?.bounds && challenge.bounds !== "null" ? 7.3 : undefined,
    };
    if (challenge?.mapOverlay) {
      return {
        ...baseOptions,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      };
    }
    return baseOptions;
  };

  // --- UI ---
  return isLoaded ? (
    <div className="view-map-page vc-page" style={{position: "relative", height: "100vh", width: "100vw"}}>
      {challenge ? (
        <>
          {/* MODALS: Waypoint, Evidence, Completion */}
          {isWpModalOpen && (
            <div className="waypoint-modal-overlay" style={{
              position: "fixed",
              inset: 0,
              zIndex: 1000,
              background: "rgba(10,40,80,0.18)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <div className="waypoint-modal" style={{
                position: "relative",
                zIndex: 1001,
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 4px 32px #0003",
                padding: 28,
                minWidth: 310,
              }}>
                <WaypointModal
                  isOpen={isWpModalOpen}
                  onClose={handleCloseWpModal}
                  getUser={getUser}
                  waypoint={waypoint}
                  status={activity?.status?.isCompleted}
                />
              </div>
            </div>
          )}
          {isEvModalOpen && (
            <div className="evidence-modal-overlay" style={{
              position: "fixed",
              inset: 0,
              zIndex: 1000,
              background: "rgba(10,40,80,0.18)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <div className="evidence-modal" style={{
                position: "relative",
                zIndex: 1001,
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 4px 32px #0003",
                padding: 28,
                minWidth: 310,
              }}>
                <EvidenceModal
                  isOpen={isEvModalOpen}
                  onClose={handleCloseEvModal}
                  getUser={getUser}
                  status={activity?.status?.isCompleted}
                  app={app}
                />
              </div>
            </div>
          )}
          {showCompletionModal && (
            <div className="completion-modal-overlay" style={{
              position: "fixed",
              inset: 0,
              zIndex: 1000,
              background: "rgba(10,40,80,0.18)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <div className="completion-modal" style={{
                position: "relative",
                zIndex: 1001,
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 4px 32px #0003",
                padding: 28,
                minWidth: 310,
              }}>
                <CompletionModal
                  onClose={() => {
                    setShowCompletionModal(false);
                    localStorage.setItem(
                      `completionModalShown_${productId}`,
                      "true"
                    );
                  }}
                />
              </div>
            </div>
          )}

          {/* MAP-first layout */}
          <div className="vc-map-shell">
            <div className="vc-map-wrap">
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={challenge.bounds && challenge.bounds !== "null" ? 7.3 : 16}
                onLoad={onMapLoad}
                options={getMapOptions()}
              >
                <>
                  {challenge?.bounds && challenge?.mapOverlay && (
                    <GroundOverlay
                      key="url"
                      url={challenge.mapOverlay}
                      bounds={JSON.parse(challenge.bounds)}
                    />
                  )}
                  {googleObj && users && challenge.pathCoordinates && (
                    <Polyline
                      onLoad={(poly) => setPolyline(poly)}
                      path={challenge.pathCoordinates}
                      options={{
                        ...options,
                        strokeColor: colorMap[productId!] || options.strokeColor,
                        strokeOpacity:
                          opacityMap[productId!] ?? options.strokeOpacity,
                      }}
                    />
                  )}
                  {markers}
                  {paceMarker}
                  {infoWindow}
                  {waypoints}
                </>
              </GoogleMap>
            </div>

            {/* Floating back button (header removed) */}
            <button className="vc-float-back" onClick={goBack} aria-label="Back">
              <img src={logo} alt="Back" />
            </button>

            {/* Floating "show all users" toggle (replaces old bottom toggle) */}
            <button
              className={
                "vc-float-users" + (isOn ? " vc-float-users--on" : "")
              }
              onClick={() => setIsOn((prev) => !prev)}
              aria-label={isOn ? "Showing all users" : "Showing only you"}
              title={isOn ? "Showing all users" : "Show all users"}
              type="button"
            >
              👥
            </button>

            {/* Bottom dock: stats + actions */}
            <div className="vc-bottom-dock">
              {activity && (
                <div className="vc-stats-card">
                  <Activity
                    activity={activity}
                    handleOpenEvModal={handleOpenEvModal}
                    handleToggle={() => setIsOn((prevState) => !prevState)}
                    variant="dock"
                    targetKm={challenge?.totalDistanceKm}
                  />
                </div>
              )}

              <div className="vc-action-row">
                <button
                  className="vc-action-btn vc-action-secondary"
                  onClick={() => {
                    if (isActivityDisabled) return;
                    handleOpenEvModal();
                  }}
                  disabled={isActivityDisabled}
                  aria-disabled={isActivityDisabled}
                  title={isActivityDisabled ? "Activity is disabled for this challenge" : ""}
                >
                  + Add Activity
                </button>
                <button
                  className="vc-action-btn vc-action-primary"
                  onClick={() => {
                    if (isMoreDisabled) return;
                    setMoreTab("timeframe");
                    setShowMoreSheet(true);
                  }}
                  disabled={isMoreDisabled}
                  aria-disabled={isMoreDisabled}
                  title={isMoreDisabled ? "More is disabled for this challenge" : ""}
                >
                  More
                </button>
              </div>
            </div>

            {/* More sheet: choose Timeframe / Leaderboard / Friends */}
            {showMoreSheet && (
              <div
                className="vc-sheet-backdrop"
                onClick={() => setShowMoreSheet(false)}
              >
                <div
                  className="vc-sheet"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="vc-sheet-handle" />

                  <div className="vc-sheet-header">
                    <div className="vc-sheet-title">More</div>
                    <button
                      className="vc-sheet-close"
                      onClick={() => setShowMoreSheet(false)}
                      aria-label="Close"
                    >
                      &times;
                    </button>
                  </div>

                  <div className="vc-sheet-tabs">
                    <button
                      className={
                        "vc-tab" + (moreTab === "timeframe" ? " vc-tab--active" : "")
                      }
                      onClick={() => setMoreTab("timeframe")}
                      type="button"
                    >
                      Timeframe
                    </button>
                    <button
                      className={
                        "vc-tab" + (moreTab === "leaderboard" ? " vc-tab--active" : "")
                      }
                      onClick={() => setMoreTab("leaderboard")}
                      type="button"
                    >
                      Leaderboard
                    </button>
                    <button
                      className={
                        "vc-tab" + (moreTab === "friends" ? " vc-tab--active" : "")
                      }
                      onClick={() => setMoreTab("friends")}
                      type="button"
                    >
                      Friends
                    </button>
                  </div>

                  {moreTab === "timeframe" && (
                    <div className="vc-sheet-section">
                      <div className="vc-section-title">Timeframe</div>
                      <div className="vc-section-row">
                        <select
                          value={selectedTimeframe?.label || ""}
                          onChange={handleTimeframeChange}
                          className="vc-select"
                        >
                          <option value="" disabled>
                            Select timeframe...
                          </option>
                          {timeframes.map((t) => (
                            <option key={t.label} value={t.label}>
                              {t.label}
                            </option>
                          ))}
                        </select>
                        <button
                          type="button"
                          className="vc-mini-btn"
                          onClick={handleResetTimeframe}
                          disabled={!selectedTimeframe}
                          title="Reset to the default pace target"
                        >
                          Expiry pace
                        </button>
                      </div>

                      {/* Make remaining time easier to read on mobile by giving it its own full-width row */}
                      <div
                        className="vc-timeleft"
                        style={{
                          marginTop: 10,
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            padding: "10px 12px",
                            borderRadius: 14,
                            fontWeight: 800,
                            fontSize: 16,
                            lineHeight: 1.2,
                            background: "rgba(39, 119, 170, 0.08)",
                          }}
                        >
                          {selectedTimeframe ? (
                            timeLeft && timeLeft !== "Time's up!" ? (
                              <span>{timeLeft} remaining</span>
                            ) : (
                              <span style={{ color: "#d33" }}>Time's up!</span>
                            )
                          ) : (
                            <span style={{ color: "#667", fontWeight: 700 }}>
                              Default pace
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="vc-helptext">
                        Setting a timeframe starts a new pace countdown from the moment you set it and paces you from your current progress. Use "Expiry pace" to return to the pace based on challenge expiry date. (Challenge expiry still applies at all times.)
                      </div>
                    </div>
                  )}

                  {moreTab === "leaderboard" && (
                    <div className="vc-sheet-section">
                      <div className="vc-section-title">Leaderboard</div>
                      <input
                        type="text"
                        placeholder="Search by name"
                        value={searchName}
                        onChange={(e) => setSearchName(e.target.value)}
                        className="vc-input"
                      />
                      <LeaderboardTable
                        users={users}
                        searchName={searchName}
                        currentUserId={userId}
                        maxDistance={challenge?.totalDistanceKm}
                      />
                    </div>
                  )}

                  {moreTab === "friends" && (
                    <div className="vc-sheet-section">
                      <div className="vc-section-title">Friends</div>
                      <div className="vc-section-row">
                        <input
                          type="text"
                          placeholder="Enter a friend's name"
                          value={friendNameInput}
                          onChange={(e) => setFriendNameInput(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleAddFriend();
                          }}
                          className="vc-input"
                        />
                        <button className="vc-mini-btn" onClick={handleAddFriend}>
                          Add
                        </button>
                      </div>
                      <div className="vc-friends-list">
                        {friendNames.length === 0 ? (
                          <div className="vc-empty">No friends yet.</div>
                        ) : (
                          friendNames.map((name) => (
                            <div className="vc-friend-item" key={name}>
                              <span>{name}</span>
                              <button
                                className="vc-remove"
                                title="Remove"
                                onClick={() => {
                                  const updated = friendNames.filter((n) => n !== name);
                                  setFriendNames(updated);
                                  localStorage.setItem(
                                    "challengeFriends",
                                    JSON.stringify(updated)
                                  );
                                }}
                              >
                                &times;
                              </button>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div className="loader"></div>
          <p>Please wait</p>
        </div>
      )}
    </div>
  ) : (
    <>Loading the Map!</>
  );
}

export default React.memo(ViewMap);
